import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useUnit } from 'effector-react';
import { $postRequestStore } from '@lib/store';
import { useRouteHook } from '@shared/hooks';
import { cn, PaletteUtils, RoutePaths } from '@shared/utils';
import type { LifestyleCategory } from '@shared/api';
import { RequestForm } from './requestForm';
import { ConfirmModal } from '@widgets';
import ConfirmIcon from '@assets/icons/confirm.svg';

interface RequestProps {
  className?: string;
  category: LifestyleCategory;
}

export const Request = (props: RequestProps) => {
  const { navigate } = useRouteHook();

  const postRequestStore = useUnit($postRequestStore.store);

  const { t } = useTranslation('concierge');

  useEffect(() => () => $postRequestStore.events.clear(), [props.category.type]);

  const confirmHandler = () => {
    navigate(RoutePaths.concierge.onNavigate());
    $postRequestStore.events.clear();
  };

  return (
    <section
      className={cn(
        'flex w-full justify-center bg-white p-6 dark:bg-soft-black',
        PaletteUtils.isVcfcPalette && 'rounded-xl dark:border dark:border-gray-black',
        props.className,
      )}
    >
      <RequestForm className='w-full max-w-xl' category={props.category} />
      <ConfirmModal
        isOpen={!!postRequestStore.data?.id}
        icon={<ConfirmIcon />}
        title={t('confirm.title')}
        description={t('confirm.description')}
        buttonTitle={t('confirm.button')}
        onClick={confirmHandler}
      />
    </section>
  );
};
